@use "ui/styles/colorsOld";
@use "ui/styles/effects";
@use "ui/styles/studio";

.wrapper {
  @include studio.themeVariables;
  color: var(--studio-color);
  position: absolute;
  width: fit-content;
  opacity: 1;
  transition: opacity 0.5s linear;
  height: auto;
  background-color: var(--studio-bg-limit);
  border-radius: studio.$studioBorderRadius;
  min-width: 100px;
  z-index: 9999;
  box-shadow: effects.$boxShadowM;
}

.subWrapper {
  position: relative;
  width: 100%;
}

.closeIconWrapper {
  position: absolute;
  top: 2px;
  right: 2px;
  cursor: pointer;
  color: var(--studio-color-light);
}

.menuTitle {
  @include studio.themeVariables;
  font-size: 15px;
  font-weight: 400;
  min-width: 120px;
  align-items: center;
  padding-top: 6px;
  min-width: 200px;
  color: var(--studio-color);
  background-color: var(--studio-bg-limit);
  border-top-left-radius: studio.$studioBorderRadius;
  border-top-right-radius: studio.$studioBorderRadius;
}
